<template>
  <div class="msg-tip">
    <span v-html="processedText" :class="device" :title="formatTime"></span>
  </div>
</template>

<script>
import Utils from '@/utils/string';

export default {
  props: {
    device: {
      type: String,
      default: 'pc',
    },
    data: Object,
  },
  computed: {
    processedText() {
      let text = this.data.content;
      // 过滤html，保留a标签
      text = Utils.filterHTML(text);
      return text;
    },
    formatTime() {
      const date = new Date(this.data.time);
      return date.toLocaleDateString() + date.toLocaleTimeString();
    },
  },
};
</script>

<style lang="less" scoped>
.msg-tip {
  font-size: 12px;
  text-align: center;
  line-height: 20px;
  // margin-left: -40px;
  span {
    background: rgba(225, 230, 240, 0.5);
    border-radius: 6px;
    color: #B4B8C4;
    padding: 2px 12px;
    display: inline-block;
    &.pc {
      background: #eceef1;
    }
    &.h5 {
      background: #fff;
    }
  }
}
</style>
